import AContainer from "../../library/ExtendedObjects/AContainer.js";
import Game_Numpad from "./Game_Numpad.js";
import Game_Title from "./Game_Title.js";
import Game_SnakeMenu from "./Game_SnakeMenu.js";
import Game from "./Game.js";
import gameData from "../../gameData.js";

export default class Game_UI extends AContainer
{
    /**
     * @param {Game} scene 
     */
    constructor(scene, onNumberSubmit)
    {
        super(scene);

        this.bg = this.create(this.scene.mid.x, 13, "ui_banner");

        this.onNumberSubmit = onNumberSubmit;

        this.notepad = this.create(148, this.scene.mid.y, "ui_notebook");
        this.menuButton = this.scene.addButton(this.scene.size.width - 85, 40, "BTN_uiMenuOff", {frameOnDown: "BTN_uiMenuOn"}, ()=>{
            scene.menu.displayPopup();
        }, this);

        this.muteButton = this.scene.addButton(this.scene.size.width - 210, 42, gameData.isMuted ? "BTN_uiVolumeOff" : "BTN_uiVolumeOn", {tintOnDown: 0xaaaaaa}, ()=>{
            gameData.isMuted = !gameData.isMuted;
            this.scene.stopSounds();
            this.muteButton.setFrame(gameData.isMuted ? "BTN_uiVolumeOff" : "BTN_uiVolumeOn", false, false);
        }, this);

        // this.correctCounter_Bg = this.create(this.scene.size.width, this.scene.size.height, "ui_counter").setOrigin(1);
        this.correctCounter = this.scene.addText(50, 80, "10", 50, null, 1, this).setOrigin(1);
        this.correctCounter.tint = 0xFFFEE0;

        this.correctLabel = this.scene.addText(50, 29, "/5 CORRECT", 35, null, 0, this).setOrigin(0);
        this.correctLabel.tint = 0x8b513c;

        // this.unitsLabel = this.scene.addText(60, 55, "UNITS:", 34, null, 2, this, "Dosis-ExtraBold");
        // this.unitsLabel.tint = 0xFFFEE0;
        // this.units_1 = this.create(150, 42, "BTN_uiUnit1_off");
        // this.units_10 = this.create(210, 42, "BTN_uiUnit10_off");
        // this.units_100 = this.create(270, 42, "BTN_uiUnit100_off");

        this.title = new Game_Title(this.scene, this);
    }

    setState(state)
    {
        this.title.setState(state);

        if(state == this.scene.states.READ || state == this.scene.states.LISTEN)
        {
            this.snakeMenu = new Game_SnakeMenu(this.scene, this);
            this.snakeMenu.onNumberSubmitted = this.onNumberSubmit;
            this.snakeMenu.onSnakeMade = this.onSnakeCreated;
        }
        else if(state == this.scene.states.COUNT)
        {
            this.numPad = new Game_Numpad(this.scene, this);
            this.numPad.onSubmit = this.onNumberSubmit;
            this.numPad.toggleVisible(true);
        }
    }

    setAvailableUnits(units)
    {
        if(units == 1) 
        {
            this.setUnit(1, this.units_1, true);
            this.setUnit(10, this.units_10, false);
            this.setUnit(100, this.units_100, false);
        }
        else if(units == 10) 
        {
            this.setUnit(1, this.units_1, true);
            this.setUnit(10, this.units_10, true);
            this.setUnit(100, this.units_100, false);
        }
        else
        {
            this.setUnit(1, this.units_1, true);
            this.setUnit(10, this.units_10, true);
            this.setUnit(100, this.units_100, true);
        }

        if(this.snakeMenu) this.snakeMenu.setUnits(units);
    }

    setUnit(unit, display, isAvailable)
    {
        return;
        if(display.isAvailable == isAvailable && display.isAvailable != null) return;
        display.isAvailable = isAvailable;

        this.scene.killTween(display);
        this.scene.addTween(display, 200, {scaleX: 1.2, scaleY: 1.2, alpha: 0}, Phaser.Math.Easing.Sine.Out, ()=>{
            display.setFrame("BTN_uiUnit" + unit + "_" + (isAvailable ? "on" : "off"), false, false);
            this.scene.addTween(display, 200, {alpha: 1}, "Bounce");
            this.scene.addTween(display, 800, {scaleX: 1, scaleY: 1}, "Bounce");
        });
    }
}